import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'
import Switch, { Case } from 'react-switch-case';

// import other components within the same project here
import Config from "composer/Config.jsx";

import Localization from "composer/Localization.jsx"

import StagePicker from "composer/views/StagePicker.jsx";
import PinEditor from "composer/views/stage/PlaybackElement/PinEditor.jsx"

import {
  Grid,
  TextField,
  FormControl,
  Select,
  MenuItem,
  Button,
  Card,
  CardHeader,
  CardMedia,
  Slider,
} from '@material-ui/core';

import {
  grey,
} from '@material-ui/core/colors'

const playbackKind = 6; // Teleport

class TeleportForm extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    var defaultPayloadData = { kind: 0 };

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      pos_x: 0,
      pos_y: 0,
      countDownLimit: 3600,
      content: "",
      triggerMode: 0,
      shouldPauseVideo: false,
      payloadData: defaultPayloadData,

      visibility: 0,
    };
    autoBind(this);

    if (this.props.playbackData != null) {
      this.state.pos_x = parseFloat(this.props.playbackData['pos_x']);
      this.state.pos_y = parseFloat(this.props.playbackData['pos_y']);
      this.state.countDownLimit = parseFloat(this.props.playbackData['countdown_limit']);
      this.state.content = this.props.playbackData['content'];
      this.state.triggerMode = this.props.playbackData['trigger_mode'];
      this.state.payloadData = (this.props.playbackData['payload'] != ""? JSON.parse(this.props.playbackData['payload']) : defaultPayloadData);
    }
    this.state.visibility = this.props.parent.countdownLimitToVisibility(this.state.countDownLimit);
  }

  visibilityChanged(e) {
    // let countDownLimit = this.props.parent.visibilityToCountdownLimit(e.target.value);
    this.setState({
      visibility: e.target.value,
      // countDownLimit: countDownLimit,
    });
    this.state.visibility = e.target.value;
    // this.state.countDownLimit = countDownLimit;
  }

  visibilitySliderChanged(e){
    const re = /^[0-9\b]+$/;
    let countDownLimit = e.target.value;
    if (countDownLimit === '' || re.test(countDownLimit)) {
      if(countDownLimit > 3600){
        countDownLimit = 3600;
      }else if (countDownLimit < 1){
        countDownLimit = 1;
      }
      this.setState({
        // visibility: e.target.value,
        countDownLimit: countDownLimit,
      });
      // this.state.visibility = e.target.value;
      this.state.countDownLimit = countDownLimit;
    }
  }

  shouldPauseVideoChanged(e){
    this.setState({
      shouldPauseVideo: e.target.value
    });
    this.state.shouldPauseVideo = e.target.value;
  }

  selectStageClicked() {
    this.refs.stagePicker.setState({
      open: true,
    });
  }

  onStagePicked(stageID) {
    let payloadData = this.state.payloadData;
    payloadData['stage_id'] = stageID;

    let stageData = this.props.root.refs.stageViewerPage.getStageDataById(stageID);
    if (stageData) {
      this.setState({
        content: stageData['stage_name'],
      });
      this.state.content = stageData['stage_name'];
      payloadData['file_id']= (stageData['movie_list'][0] == null? -1 : stageData['movie_list'][0]['tn_file_id']);
    }
    this.setState({
      payloadData: payloadData,
    });
    this.state.payloadData = payloadData;
  }

  validateInput() {
    let result = true;
    if (this.state.payloadData['stage_id'] == null) {
      this.props.root.addNotification("Please choose at least one stage");
      result = false;
    }
    return result;
  }

  updatePlayback(new_id) {
    let requestObj = {
      playback_id: new_id,
      kind: playbackKind,
      trigger_time: (this.props.playbackData? this.props.playbackData['trigger_time'] : this.props.root.refs.stageViewerPage.refs.stageDetailView.refs.stageMediaView.state.playbackTime),
      should_pause_video: (this.state.shouldPauseVideo? 1 : 0),
      pos_x: this.state.pos_x,
      pos_y: this.state.pos_y,
      countdown_limit: this.state.countDownLimit,
      content: this.state.content.trim(),
      payload: JSON.stringify(this.state.payloadData),
    };
    this.props.root.refs.API.request("update_playback", requestObj, this.props.parent.updatePlaybackOK, this.props.parent.updatePlaybackFailed);
  }

  onPinPositionUpdate(pos) {
    this.setState({
      pos_x: pos.x,
      pos_y: pos.y,
    });
    this.state.pos_x = pos.x;
    this.state.pos_y = pos.y;
  }

  getStageChoice() {
    let stage_id = (this.state.payloadData['stage_id']? this.state.payloadData['stage_id'] : 0);
    let stageData = this.props.root.refs.stageViewerPage.getStageDataById(stage_id);
    let tn_path = "";
    let stage_name = "";
    if (stageData != null) {
      tn_path = (stageData['movie_list'][0] != null?
        Config.BASE_PATH() + stageData['movie_list'][0]['tn_path']
        : "");
      stage_name = stageData['stage_name'];
    }
    return (
      <Grid item xs={12} sm={6}>
        <Card style={{margin:"5px"}}>
          <CardHeader
            titleTypographyProps={{variant:"subtitle1"}}
            title={stage_name}
          />
          <CardMedia image="/" style={{display:'flex', alignItems:'center', justifyContent:'center', backgroundColor:grey[200], height:"20vh"}}>
            <If condition={stageData == null || tn_path == ""}>
              <Then>
                <div>
                  <Button
                    onClick={this.selectStageClicked}
                    variant={stageData == null? "text" : "contained"}
                    color={stageData == null? "default" : "primary"}
                  >
                    {stageData == null? Localization.strings.SELECT_STAGE : stage_name}
                  </Button>
                </div>
              </Then>
              <Else>
                <img
                  style={{cursor: "pointer", maxHeight:"100%", maxWidth:"100%", display:"block", margin:"auto"}}
                  src={tn_path}
                  onClick={this.selectStageClicked}
                />
              </Else>
            </If>
          </CardMedia>
        </Card>
      </Grid>
    );
  }

  render() {
    return (
      <div>
        <StagePicker parent={this} root={this.props.root} ref="stagePicker"/>
        <Switch condition={this.props.parent.state.activeView}>
          <Case value={0}>
            <PinEditor parent={this} root={this.props.root} ref="pinEditor"
              db_x={this.state.pos_x} db_y={this.state.pos_y}
            />
          </Case>
          <Case value={1}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={2}>
                {Localization.strings.PAUSE_VIDEO}
              </Grid>
              <Grid item xs={12} sm={10}>
                <FormControl>
                  <Select
                    value={this.state.shouldPauseVideo}
                    onChange={this.shouldPauseVideoChanged}
                  >
                    <MenuItem value={false}>{Localization.strings.NO}</MenuItem>
                    <MenuItem value={true}>{Localization.strings.YES}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={2}>
                {Localization.strings.VISIBILITY}
              </Grid>
              <Grid item xs={12} sm={10}>
              <FormControl>
                  <Select
                    value={this.state.visibility}
                    onChange={this.visibilityChanged}
                  >
                    <MenuItem value={0}>{Localization.strings.ALWAYS}</MenuItem>
                    <MenuItem value={1}>{Localization.strings.CUSTOMIZE}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <If condition={this.state.visibility != 0}>
                <Then>
                <Grid item xs={12} sm={2}>
                  {Localization.strings.VISIBILITY_DURATION}
                  </Grid>
                  <Grid item xs={12} sm={10}>
                    <TextField value={this.state.countDownLimit} onChange={this.visibilitySliderChanged} />
                  </Grid>
                </Then>
              </If>
              <Grid item xs={12} sm={2}>
                {Localization.strings.DESTINATION}
              </Grid>
              {this.getStageChoice()}
            </Grid>
          </Case>
        </Switch>
      </div>
    )
  }
}

export default TeleportForm;
